import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchDayNotesArgs } from '../api/dayNote.api';

import { fetchDayNotes } from '../api/dayNote.api';

export const dayNoteQueryKeys = createQueryKeys('dayNotes', {
  fetchDayNotes: (args: FetchDayNotesArgs) => ({
    queryFn: () => fetchDayNotes(args),
    queryKey: [args.organizationId, args],
  }),
});
